module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.render_flag) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_flag),
      expression: "show_flag"
    }],
    staticClass: "big-pop",
    class: {
      'black-bg': _vm.black
    }
  }, [_c('div', {
    staticClass: "main",
    style: ({
      height: _vm.height,
      width: _vm.width
    })
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "title": _vm.tip ? _vm.title : ''
    }
  }, [_vm._v(_vm._s(_vm._f("titleLimit")(_vm.title)))]), _vm._v(" "), _vm._t("tab-title"), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("assets/image/back-close.svg")
    },
    on: {
      "click": _vm.close
    }
  })], 2), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "wrap"
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.noBtns) ? _c('div', {
    staticClass: "btns"
  }, [(_vm.btnshow) ? _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.savetext))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.canceltext))])]) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-ce6863cc!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/windowPop.vue
// module id = 786
// module chunks = 1